import classnames from 'classnames/bind'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'

// Components
import CollectionIcon from '../CollectionIcon'

// Methods
import { helpCollectionPath } from '../../methods'

// Types
import type { HelpCollectionItem } from '@/api/fetchHelpArticle'

// Styles
import styles from '../../style.module.scss'

const cx = classnames.bind(styles)

type Props = {
  collections: HelpCollectionItem[]
  /** 目前所在的第一層分類 */
  activeId: number
  countryQuery?: string
}

/** 分類頁左側：全部第一層分類（手機改成可橫向捲動的標籤列） */
const CollectionNav = ({ collections, activeId, countryQuery }: Props) => {
  const { t } = useTranslation()

  return (
    <nav className={cx('help-nav')} aria-label={t('Help_Center_All_Collections')}>
      <p className={cx('help-nav__title')}>{t('Help_Center_All_Collections')}</p>
      <ul>
        {collections.map((collection) => (
          <li key={collection.id}>
            <Link
              className={cx('help-nav__item', { 'help-nav__item--active': collection.id === activeId })}
              href={helpCollectionPath(collection.id, countryQuery)}
              aria-current={collection.id === activeId ? 'page' : undefined}
            >
              <CollectionIcon src={collection.iconUrl} size={20} />
              <span className={cx('help-nav__name')}>{collection.name}</span>
              <span className={cx('help-nav__count')}>{collection.articleCount}</span>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  )
}

export default CollectionNav
